import * as resApi from "../../api/ResumeApi";
import * as log from "../../utility/logging/logger";
import { getField, updateField } from "vuex-map-fields";

function resetState(state) {
  state.displayValue = "";
  state.addressLine1 = "";
  state.addressLine2 = "";
  state.city = "";
  state.state = "";
  state.country = "";
  state.zipCode = "";
  state.phoneNumber = "";
  state.email = "";
}

const addressModule = {
  namespaced: true,
  state: {
    displayValue: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    phoneNumber: "",
    email: ""
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    loadData(state, payload) {
      log.logTrace("Loading Address Module", "address_store.loadData");
      state.displayValue = payload.displayValue;
      state.addressLine1 = payload.addressLine1;
      state.addressLine2 = payload.addressLine2;
      state.city = payload.city;
      state.state = payload.state;
      state.country = payload.country;
      state.zipCode = payload.zipCode;
      state.phoneNumber = payload.phoneNumber;
      state.email = payload.email;
    },
    removeResume(state) {
      resetState(state);
    },
    logout(state) {
      resetState(state);
    }
  },
  actions: {
    async saveAddress(context) {
      let result = await resApi.PostAddress({
        resumeId: context.rootState.resumeId,
        displayValue: context.state.displayValue,
        addressLine1: context.state.addressLine1,
        addressLine2: context.state.addressLine2,
        city: context.state.city,
        state: context.state.state,
        country: context.state.country,
        zipCode: context.state.zipCode,
        phoneNumber: context.state.phoneNumber,
        email: context.state.email
      });
      if (!result.success) {
        log.logWarning(
          "Failed to save address data",
          "address_store.saveAddress"
        );
      }
    }
  }
};

export { addressModule };
